import { connect } from "react-redux";

import { FullFormState } from "../../../../Engine/Core/Store/FullFormState";
import { withCandyApiDraftClient } from "../../../withCandyApiDraftClient";

import { PrintErrorLogButton } from "./PrintErrorLogButton";

const mapStateToProps = (state: FullFormState) => {
    const { errorLogName, propsName } = state.errorLog.form;

    return {
        propsName: propsName ?? "",
        errorLogName: errorLogName ?? "",
    };
};

export const PrintErrorLogButtonContainer = withCandyApiDraftClient(connect(mapStateToProps)(PrintErrorLogButton));
